import React from "react";

const WishlistHeader = () => {
  return (
    <div className="cart-header-row desktop-only">
      <div>Sản phẩm</div>
      <div className="text-center">Chức năng</div>
      <div className="text-center"></div>
    </div>
  );
};

export default WishlistHeader;
